import { render, staticRenderFns } from "./ItemDescription.vue?vue&type=template&id=2eca9aff&scoped=true&lang=pug&"
import script from "./ItemDescription.vue?vue&type=script&lang=js&"
export * from "./ItemDescription.vue?vue&type=script&lang=js&"
import style0 from "./ItemDescription.vue?vue&type=style&index=0&id=2eca9aff&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eca9aff",
  null
  
)

export default component.exports